import React, { useContext, useMemo } from "react";
import Breadcrumbs from "@_components/breadcrumbs";
import hasContainer from "@root/helpers/has-container";
import { CategoryContext } from "@root/context/category";

const BreadcrumbsModule = ({ data }) => {
    if (!data) return null;

    const { currentCategory, navigateToCategory, pageData } = useContext(CategoryContext) || {};

    const items = useMemo(() => {
        if (currentCategory?.paths) {
            return [
                { title: "Home", url: "/" },
                ...currentCategory.paths.map((path) => {
                    return {
                        slug: path?.slug,
                        title: path?.name,
                        url: path?.slug === pageData?.categorySlug ? pageData?.handle?.current : `${pageData?.handle?.current}/${path.slug}`,
                        onClick: (e, item) => {
                            e.preventDefault();
                            navigateToCategory(item);
                        },
                    };
                }),
            ];
        }

        return data.items || [];
    }, [currentCategory]);

    return (
        <div className={`${hasContainer(data?.moduleSettings?.hasContainer) !== "container" ? "p-0" : "container"}`}>
            <Breadcrumbs items={items} />
        </div>
    );
};

export default BreadcrumbsModule;
